/*eslint-disable block-scoped-var, no-redeclare, no-control-regex, no-prototype-builtins*/
import * as $protobuf from "protobufjs";

// Common aliases
const $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
const $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

export const stomp = $root.stomp = (() => {

    /**
     * Namespace stomp.
     * @exports stomp
     * @namespace
     */
    const stomp = {};

    stomp.Heartbeat = (function() {

        /**
         * Properties of a Heartbeat.
         * @typedef stomp.Heartbeat$Properties
         * @type {Object}
         */

        /**
         * Constructs a new Heartbeat.
         * @exports stomp.Heartbeat
         * @constructor
         * @param {stomp.Heartbeat$Properties=} [properties] Properties to set
         */
        function Heartbeat(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new Heartbeat instance using the specified properties.
         * @param {stomp.Heartbeat$Properties=} [properties] Properties to set
         * @returns {stomp.Heartbeat} Heartbeat instance
         */
        Heartbeat.create = function create(properties) {
            return new Heartbeat(properties);
        };

        /**
         * Encodes the specified Heartbeat message. Does not implicitly {@link stomp.Heartbeat.verify|verify} messages.
         * @param {stomp.Heartbeat$Properties} message Heartbeat message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        Heartbeat.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a Heartbeat message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.Heartbeat} Heartbeat
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        Heartbeat.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.Heartbeat();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a Heartbeat message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        Heartbeat.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a Heartbeat message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.Heartbeat} Heartbeat
         */
        Heartbeat.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.Heartbeat)
                return object;
            return new $root.stomp.Heartbeat();
        };

        /**
         * Creates a Heartbeat message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.Heartbeat.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.Heartbeat} Heartbeat
         */
        Heartbeat.from = Heartbeat.fromObject;

        /**
         * Creates a plain object from a Heartbeat message. Also converts values to other types if specified.
         * @param {stomp.Heartbeat} message Heartbeat
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Heartbeat.toObject = function toObject() {
            return {};
        };

        /**
         * Creates a plain object from this Heartbeat message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        Heartbeat.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this Heartbeat to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        Heartbeat.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return Heartbeat;
    })();

    stomp.ConnectRequest = (function() {

        /**
         * Properties of a ConnectRequest.
         * @typedef stomp.ConnectRequest$Properties
         * @type {Object}
         * @property {string} [acceptVersion] ConnectRequest acceptVersion.
         * @property {string} [login] ConnectRequest login.
         * @property {string} [passcode] ConnectRequest passcode.
         * @property {Uint8Array} [body] ConnectRequest body.
         */

        /**
         * Constructs a new ConnectRequest.
         * @exports stomp.ConnectRequest
         * @constructor
         * @param {stomp.ConnectRequest$Properties=} [properties] Properties to set
         */
        function ConnectRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ConnectRequest acceptVersion.
         * @type {string}
         */
        ConnectRequest.prototype.acceptVersion = "";

        /**
         * ConnectRequest login.
         * @type {string}
         */
        ConnectRequest.prototype.login = "";

        /**
         * ConnectRequest passcode.
         * @type {string}
         */
        ConnectRequest.prototype.passcode = "";

        /**
         * ConnectRequest body.
         * @type {Uint8Array}
         */
        ConnectRequest.prototype.body = $util.newBuffer([]);

        /**
         * Creates a new ConnectRequest instance using the specified properties.
         * @param {stomp.ConnectRequest$Properties=} [properties] Properties to set
         * @returns {stomp.ConnectRequest} ConnectRequest instance
         */
        ConnectRequest.create = function create(properties) {
            return new ConnectRequest(properties);
        };

        /**
         * Encodes the specified ConnectRequest message. Does not implicitly {@link stomp.ConnectRequest.verify|verify} messages.
         * @param {stomp.ConnectRequest$Properties} message ConnectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConnectRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.acceptVersion != null && message.hasOwnProperty("acceptVersion"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.acceptVersion);
            if (message.login != null && message.hasOwnProperty("login"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.login);
            if (message.passcode != null && message.hasOwnProperty("passcode"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.passcode);
            if (message.body != null && message.hasOwnProperty("body"))
                writer.uint32(/* id 4, wireType 2 =*/34).bytes(message.body);
            return writer;
        };

        /**
         * Decodes a ConnectRequest message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.ConnectRequest} ConnectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConnectRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.ConnectRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.acceptVersion = reader.string();
                    break;
                case 2:
                    message.login = reader.string();
                    break;
                case 3:
                    message.passcode = reader.string();
                    break;
                case 4:
                    message.body = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a ConnectRequest message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        ConnectRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.acceptVersion != null && message.hasOwnProperty("acceptVersion"))
                if (!$util.isString(message.acceptVersion))
                    return "acceptVersion: string expected";
            if (message.login != null && message.hasOwnProperty("login"))
                if (!$util.isString(message.login))
                    return "login: string expected";
            if (message.passcode != null && message.hasOwnProperty("passcode"))
                if (!$util.isString(message.passcode))
                    return "passcode: string expected";
            if (message.body != null && message.hasOwnProperty("body"))
                if (!(message.body && typeof message.body.length === "number" || $util.isString(message.body)))
                    return "body: buffer expected";
            return null;
        };

        /**
         * Creates a ConnectRequest message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ConnectRequest} ConnectRequest
         */
        ConnectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.ConnectRequest)
                return object;
            let message = new $root.stomp.ConnectRequest();
            if (object.acceptVersion != null)
                message.acceptVersion = String(object.acceptVersion);
            if (object.login != null)
                message.login = String(object.login);
            if (object.passcode != null)
                message.passcode = String(object.passcode);
            if (object.body != null)
                if (typeof object.body === "string")
                    $util.base64.decode(object.body, message.body = $util.newBuffer($util.base64.length(object.body)), 0);
                else if (object.body.length)
                    message.body = object.body;
            return message;
        };

        /**
         * Creates a ConnectRequest message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.ConnectRequest.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ConnectRequest} ConnectRequest
         */
        ConnectRequest.from = ConnectRequest.fromObject;

        /**
         * Creates a plain object from a ConnectRequest message. Also converts values to other types if specified.
         * @param {stomp.ConnectRequest} message ConnectRequest
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConnectRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.acceptVersion = "";
                object.login = "";
                object.passcode = "";
                object.body = options.bytes === String ? "" : [];
            }
            if (message.acceptVersion != null && message.hasOwnProperty("acceptVersion"))
                object.acceptVersion = message.acceptVersion;
            if (message.login != null && message.hasOwnProperty("login"))
                object.login = message.login;
            if (message.passcode != null && message.hasOwnProperty("passcode"))
                object.passcode = message.passcode;
            if (message.body != null && message.hasOwnProperty("body"))
                object.body = options.bytes === String ? $util.base64.encode(message.body, 0, message.body.length) : options.bytes === Array ? Array.prototype.slice.call(message.body) : message.body;
            return object;
        };

        /**
         * Creates a plain object from this ConnectRequest message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConnectRequest.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this ConnectRequest to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        ConnectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ConnectRequest;
    })();

    stomp.DisconnectRequest = (function() {

        /**
         * Properties of a DisconnectRequest.
         * @typedef stomp.DisconnectRequest$Properties
         * @type {Object}
         */

        /**
         * Constructs a new DisconnectRequest.
         * @exports stomp.DisconnectRequest
         * @constructor
         * @param {stomp.DisconnectRequest$Properties=} [properties] Properties to set
         */
        function DisconnectRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * Creates a new DisconnectRequest instance using the specified properties.
         * @param {stomp.DisconnectRequest$Properties=} [properties] Properties to set
         * @returns {stomp.DisconnectRequest} DisconnectRequest instance
         */
        DisconnectRequest.create = function create(properties) {
            return new DisconnectRequest(properties);
        };

        /**
         * Encodes the specified DisconnectRequest message. Does not implicitly {@link stomp.DisconnectRequest.verify|verify} messages.
         * @param {stomp.DisconnectRequest$Properties} message DisconnectRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        DisconnectRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            return writer;
        };

        /**
         * Decodes a DisconnectRequest message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.DisconnectRequest} DisconnectRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        DisconnectRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.DisconnectRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a DisconnectRequest message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        DisconnectRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            return null;
        };

        /**
         * Creates a DisconnectRequest message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.DisconnectRequest} DisconnectRequest
         */
        DisconnectRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.DisconnectRequest)
                return object;
            return new $root.stomp.DisconnectRequest();
        };

        /**
         * Creates a DisconnectRequest message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.DisconnectRequest.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.DisconnectRequest} DisconnectRequest
         */
        DisconnectRequest.from = DisconnectRequest.fromObject;

        /**
         * Creates a plain object from a DisconnectRequest message. Also converts values to other types if specified.
         * @param {stomp.DisconnectRequest} message DisconnectRequest
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DisconnectRequest.toObject = function toObject() {
            return {};
        };

        /**
         * Creates a plain object from this DisconnectRequest message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        DisconnectRequest.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this DisconnectRequest to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        DisconnectRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return DisconnectRequest;
    })();

    stomp.SubscribeRequest = (function() {

        /**
         * Properties of a SubscribeRequest.
         * @typedef stomp.SubscribeRequest$Properties
         * @type {Object}
         * @property {string} [destination] SubscribeRequest destination.
         * @property {number|Long} [subscriptionId] SubscribeRequest subscriptionId.
         * @property {number} [throttleRate] SubscribeRequest throttleRate.
         * @property {number|Long} [receiptId] SubscribeRequest receiptId.
         */

        /**
         * Constructs a new SubscribeRequest.
         * @exports stomp.SubscribeRequest
         * @constructor
         * @param {stomp.SubscribeRequest$Properties=} [properties] Properties to set
         */
        function SubscribeRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SubscribeRequest destination.
         * @type {string}
         */
        SubscribeRequest.prototype.destination = "";

        /**
         * SubscribeRequest subscriptionId.
         * @type {number|Long}
         */
        SubscribeRequest.prototype.subscriptionId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SubscribeRequest throttleRate.
         * @type {number}
         */
        SubscribeRequest.prototype.throttleRate = 0;

        /**
         * SubscribeRequest receiptId.
         * @type {number|Long}
         */
        SubscribeRequest.prototype.receiptId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new SubscribeRequest instance using the specified properties.
         * @param {stomp.SubscribeRequest$Properties=} [properties] Properties to set
         * @returns {stomp.SubscribeRequest} SubscribeRequest instance
         */
        SubscribeRequest.create = function create(properties) {
            return new SubscribeRequest(properties);
        };

        /**
         * Encodes the specified SubscribeRequest message. Does not implicitly {@link stomp.SubscribeRequest.verify|verify} messages.
         * @param {stomp.SubscribeRequest$Properties} message SubscribeRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SubscribeRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.destination != null && message.hasOwnProperty("destination"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.destination);
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.subscriptionId);
            if (message.throttleRate != null && message.hasOwnProperty("throttleRate"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint32(message.throttleRate);
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.receiptId);
            return writer;
        };

        /**
         * Decodes a SubscribeRequest message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.SubscribeRequest} SubscribeRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SubscribeRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.SubscribeRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.destination = reader.string();
                    break;
                case 2:
                    message.subscriptionId = reader.uint64();
                    break;
                case 3:
                    message.throttleRate = reader.uint32();
                    break;
                case 4:
                    message.receiptId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a SubscribeRequest message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        SubscribeRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.destination != null && message.hasOwnProperty("destination"))
                if (!$util.isString(message.destination))
                    return "destination: string expected";
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (!$util.isInteger(message.subscriptionId) && !(message.subscriptionId && $util.isInteger(message.subscriptionId.low) && $util.isInteger(message.subscriptionId.high)))
                    return "subscriptionId: integer|Long expected";
            if (message.throttleRate != null && message.hasOwnProperty("throttleRate"))
                if (!$util.isInteger(message.throttleRate))
                    return "throttleRate: integer expected";
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (!$util.isInteger(message.receiptId) && !(message.receiptId && $util.isInteger(message.receiptId.low) && $util.isInteger(message.receiptId.high)))
                    return "receiptId: integer|Long expected";
            return null;
        };

        /**
         * Creates a SubscribeRequest message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.SubscribeRequest} SubscribeRequest
         */
        SubscribeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.SubscribeRequest)
                return object;
            let message = new $root.stomp.SubscribeRequest();
            if (object.destination != null)
                message.destination = String(object.destination);
            if (object.subscriptionId != null)
                if ($util.Long)
                    (message.subscriptionId = $util.Long.fromValue(object.subscriptionId)).unsigned = true;
                else if (typeof object.subscriptionId === "string")
                    message.subscriptionId = parseInt(object.subscriptionId, 10);
                else if (typeof object.subscriptionId === "number")
                    message.subscriptionId = object.subscriptionId;
                else if (typeof object.subscriptionId === "object")
                    message.subscriptionId = new $util.LongBits(object.subscriptionId.low >>> 0, object.subscriptionId.high >>> 0).toNumber(true);
            if (object.throttleRate != null)
                message.throttleRate = object.throttleRate >>> 0;
            if (object.receiptId != null)
                if ($util.Long)
                    (message.receiptId = $util.Long.fromValue(object.receiptId)).unsigned = true;
                else if (typeof object.receiptId === "string")
                    message.receiptId = parseInt(object.receiptId, 10);
                else if (typeof object.receiptId === "number")
                    message.receiptId = object.receiptId;
                else if (typeof object.receiptId === "object")
                    message.receiptId = new $util.LongBits(object.receiptId.low >>> 0, object.receiptId.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a SubscribeRequest message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.SubscribeRequest.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.SubscribeRequest} SubscribeRequest
         */
        SubscribeRequest.from = SubscribeRequest.fromObject;

        /**
         * Creates a plain object from a SubscribeRequest message. Also converts values to other types if specified.
         * @param {stomp.SubscribeRequest} message SubscribeRequest
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SubscribeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.destination = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.subscriptionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.subscriptionId = options.longs === String ? "0" : 0;
                object.throttleRate = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.receiptId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiptId = options.longs === String ? "0" : 0;
            }
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = message.destination;
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (typeof message.subscriptionId === "number")
                    object.subscriptionId = options.longs === String ? String(message.subscriptionId) : message.subscriptionId;
                else
                    object.subscriptionId = options.longs === String ? $util.Long.prototype.toString.call(message.subscriptionId) : options.longs === Number ? new $util.LongBits(message.subscriptionId.low >>> 0, message.subscriptionId.high >>> 0).toNumber(true) : message.subscriptionId;
            if (message.throttleRate != null && message.hasOwnProperty("throttleRate"))
                object.throttleRate = message.throttleRate;
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (typeof message.receiptId === "number")
                    object.receiptId = options.longs === String ? String(message.receiptId) : message.receiptId;
                else
                    object.receiptId = options.longs === String ? $util.Long.prototype.toString.call(message.receiptId) : options.longs === Number ? new $util.LongBits(message.receiptId.low >>> 0, message.receiptId.high >>> 0).toNumber(true) : message.receiptId;
            return object;
        };

        /**
         * Creates a plain object from this SubscribeRequest message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SubscribeRequest.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this SubscribeRequest to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        SubscribeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SubscribeRequest;
    })();

    stomp.UnsubscribeRequest = (function() {

        /**
         * Properties of an UnsubscribeRequest.
         * @typedef stomp.UnsubscribeRequest$Properties
         * @type {Object}
         * @property {number|Long} [subscriptionId] UnsubscribeRequest subscriptionId.
         * @property {number|Long} [receiptId] UnsubscribeRequest receiptId.
         */

        /**
         * Constructs a new UnsubscribeRequest.
         * @exports stomp.UnsubscribeRequest
         * @constructor
         * @param {stomp.UnsubscribeRequest$Properties=} [properties] Properties to set
         */
        function UnsubscribeRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * UnsubscribeRequest subscriptionId.
         * @type {number|Long}
         */
        UnsubscribeRequest.prototype.subscriptionId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * UnsubscribeRequest receiptId.
         * @type {number|Long}
         */
        UnsubscribeRequest.prototype.receiptId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new UnsubscribeRequest instance using the specified properties.
         * @param {stomp.UnsubscribeRequest$Properties=} [properties] Properties to set
         * @returns {stomp.UnsubscribeRequest} UnsubscribeRequest instance
         */
        UnsubscribeRequest.create = function create(properties) {
            return new UnsubscribeRequest(properties);
        };

        /**
         * Encodes the specified UnsubscribeRequest message. Does not implicitly {@link stomp.UnsubscribeRequest.verify|verify} messages.
         * @param {stomp.UnsubscribeRequest$Properties} message UnsubscribeRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        UnsubscribeRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.subscriptionId);
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.receiptId);
            return writer;
        };

        /**
         * Decodes an UnsubscribeRequest message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.UnsubscribeRequest} UnsubscribeRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        UnsubscribeRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.UnsubscribeRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.subscriptionId = reader.uint64();
                    break;
                case 2:
                    message.receiptId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies an UnsubscribeRequest message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        UnsubscribeRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (!$util.isInteger(message.subscriptionId) && !(message.subscriptionId && $util.isInteger(message.subscriptionId.low) && $util.isInteger(message.subscriptionId.high)))
                    return "subscriptionId: integer|Long expected";
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (!$util.isInteger(message.receiptId) && !(message.receiptId && $util.isInteger(message.receiptId.low) && $util.isInteger(message.receiptId.high)))
                    return "receiptId: integer|Long expected";
            return null;
        };

        /**
         * Creates an UnsubscribeRequest message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.UnsubscribeRequest} UnsubscribeRequest
         */
        UnsubscribeRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.UnsubscribeRequest)
                return object;
            let message = new $root.stomp.UnsubscribeRequest();
            if (object.subscriptionId != null)
                if ($util.Long)
                    (message.subscriptionId = $util.Long.fromValue(object.subscriptionId)).unsigned = true;
                else if (typeof object.subscriptionId === "string")
                    message.subscriptionId = parseInt(object.subscriptionId, 10);
                else if (typeof object.subscriptionId === "number")
                    message.subscriptionId = object.subscriptionId;
                else if (typeof object.subscriptionId === "object")
                    message.subscriptionId = new $util.LongBits(object.subscriptionId.low >>> 0, object.subscriptionId.high >>> 0).toNumber(true);
            if (object.receiptId != null)
                if ($util.Long)
                    (message.receiptId = $util.Long.fromValue(object.receiptId)).unsigned = true;
                else if (typeof object.receiptId === "string")
                    message.receiptId = parseInt(object.receiptId, 10);
                else if (typeof object.receiptId === "number")
                    message.receiptId = object.receiptId;
                else if (typeof object.receiptId === "object")
                    message.receiptId = new $util.LongBits(object.receiptId.low >>> 0, object.receiptId.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates an UnsubscribeRequest message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.UnsubscribeRequest.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.UnsubscribeRequest} UnsubscribeRequest
         */
        UnsubscribeRequest.from = UnsubscribeRequest.fromObject;

        /**
         * Creates a plain object from an UnsubscribeRequest message. Also converts values to other types if specified.
         * @param {stomp.UnsubscribeRequest} message UnsubscribeRequest
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UnsubscribeRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.subscriptionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.subscriptionId = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.receiptId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiptId = options.longs === String ? "0" : 0;
            }
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (typeof message.subscriptionId === "number")
                    object.subscriptionId = options.longs === String ? String(message.subscriptionId) : message.subscriptionId;
                else
                    object.subscriptionId = options.longs === String ? $util.Long.prototype.toString.call(message.subscriptionId) : options.longs === Number ? new $util.LongBits(message.subscriptionId.low >>> 0, message.subscriptionId.high >>> 0).toNumber(true) : message.subscriptionId;
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (typeof message.receiptId === "number")
                    object.receiptId = options.longs === String ? String(message.receiptId) : message.receiptId;
                else
                    object.receiptId = options.longs === String ? $util.Long.prototype.toString.call(message.receiptId) : options.longs === Number ? new $util.LongBits(message.receiptId.low >>> 0, message.receiptId.high >>> 0).toNumber(true) : message.receiptId;
            return object;
        };

        /**
         * Creates a plain object from this UnsubscribeRequest message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        UnsubscribeRequest.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this UnsubscribeRequest to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        UnsubscribeRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return UnsubscribeRequest;
    })();

    stomp.ThrottleRequest = (function() {

        /**
         * Properties of a ThrottleRequest.
         * @typedef stomp.ThrottleRequest$Properties
         * @type {Object}
         * @property {number|Long} [subscriptionId] ThrottleRequest subscriptionId.
         * @property {number} [throttleRate] ThrottleRequest throttleRate.
         * @property {number|Long} [receiptId] ThrottleRequest receiptId.
         */

        /**
         * Constructs a new ThrottleRequest.
         * @exports stomp.ThrottleRequest
         * @constructor
         * @param {stomp.ThrottleRequest$Properties=} [properties] Properties to set
         */
        function ThrottleRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ThrottleRequest subscriptionId.
         * @type {number|Long}
         */
        ThrottleRequest.prototype.subscriptionId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * ThrottleRequest throttleRate.
         * @type {number}
         */
        ThrottleRequest.prototype.throttleRate = 0;

        /**
         * ThrottleRequest receiptId.
         * @type {number|Long}
         */
        ThrottleRequest.prototype.receiptId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ThrottleRequest instance using the specified properties.
         * @param {stomp.ThrottleRequest$Properties=} [properties] Properties to set
         * @returns {stomp.ThrottleRequest} ThrottleRequest instance
         */
        ThrottleRequest.create = function create(properties) {
            return new ThrottleRequest(properties);
        };

        /**
         * Encodes the specified ThrottleRequest message. Does not implicitly {@link stomp.ThrottleRequest.verify|verify} messages.
         * @param {stomp.ThrottleRequest$Properties} message ThrottleRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ThrottleRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.subscriptionId);
            if (message.throttleRate != null && message.hasOwnProperty("throttleRate"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint32(message.throttleRate);
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                writer.uint32(/* id 3, wireType 0 =*/24).uint64(message.receiptId);
            return writer;
        };

        /**
         * Decodes a ThrottleRequest message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.ThrottleRequest} ThrottleRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ThrottleRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.ThrottleRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.subscriptionId = reader.uint64();
                    break;
                case 2:
                    message.throttleRate = reader.uint32();
                    break;
                case 3:
                    message.receiptId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a ThrottleRequest message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        ThrottleRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (!$util.isInteger(message.subscriptionId) && !(message.subscriptionId && $util.isInteger(message.subscriptionId.low) && $util.isInteger(message.subscriptionId.high)))
                    return "subscriptionId: integer|Long expected";
            if (message.throttleRate != null && message.hasOwnProperty("throttleRate"))
                if (!$util.isInteger(message.throttleRate))
                    return "throttleRate: integer expected";
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (!$util.isInteger(message.receiptId) && !(message.receiptId && $util.isInteger(message.receiptId.low) && $util.isInteger(message.receiptId.high)))
                    return "receiptId: integer|Long expected";
            return null;
        };

        /**
         * Creates a ThrottleRequest message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ThrottleRequest} ThrottleRequest
         */
        ThrottleRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.ThrottleRequest)
                return object;
            let message = new $root.stomp.ThrottleRequest();
            if (object.subscriptionId != null)
                if ($util.Long)
                    (message.subscriptionId = $util.Long.fromValue(object.subscriptionId)).unsigned = true;
                else if (typeof object.subscriptionId === "string")
                    message.subscriptionId = parseInt(object.subscriptionId, 10);
                else if (typeof object.subscriptionId === "number")
                    message.subscriptionId = object.subscriptionId;
                else if (typeof object.subscriptionId === "object")
                    message.subscriptionId = new $util.LongBits(object.subscriptionId.low >>> 0, object.subscriptionId.high >>> 0).toNumber(true);
            if (object.throttleRate != null)
                message.throttleRate = object.throttleRate >>> 0;
            if (object.receiptId != null)
                if ($util.Long)
                    (message.receiptId = $util.Long.fromValue(object.receiptId)).unsigned = true;
                else if (typeof object.receiptId === "string")
                    message.receiptId = parseInt(object.receiptId, 10);
                else if (typeof object.receiptId === "number")
                    message.receiptId = object.receiptId;
                else if (typeof object.receiptId === "object")
                    message.receiptId = new $util.LongBits(object.receiptId.low >>> 0, object.receiptId.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a ThrottleRequest message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.ThrottleRequest.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ThrottleRequest} ThrottleRequest
         */
        ThrottleRequest.from = ThrottleRequest.fromObject;

        /**
         * Creates a plain object from a ThrottleRequest message. Also converts values to other types if specified.
         * @param {stomp.ThrottleRequest} message ThrottleRequest
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ThrottleRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.subscriptionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.subscriptionId = options.longs === String ? "0" : 0;
                object.throttleRate = 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.receiptId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiptId = options.longs === String ? "0" : 0;
            }
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (typeof message.subscriptionId === "number")
                    object.subscriptionId = options.longs === String ? String(message.subscriptionId) : message.subscriptionId;
                else
                    object.subscriptionId = options.longs === String ? $util.Long.prototype.toString.call(message.subscriptionId) : options.longs === Number ? new $util.LongBits(message.subscriptionId.low >>> 0, message.subscriptionId.high >>> 0).toNumber(true) : message.subscriptionId;
            if (message.throttleRate != null && message.hasOwnProperty("throttleRate"))
                object.throttleRate = message.throttleRate;
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (typeof message.receiptId === "number")
                    object.receiptId = options.longs === String ? String(message.receiptId) : message.receiptId;
                else
                    object.receiptId = options.longs === String ? $util.Long.prototype.toString.call(message.receiptId) : options.longs === Number ? new $util.LongBits(message.receiptId.low >>> 0, message.receiptId.high >>> 0).toNumber(true) : message.receiptId;
            return object;
        };

        /**
         * Creates a plain object from this ThrottleRequest message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ThrottleRequest.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this ThrottleRequest to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        ThrottleRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ThrottleRequest;
    })();

    stomp.SendRequest = (function() {

        /**
         * Properties of a SendRequest.
         * @typedef stomp.SendRequest$Properties
         * @type {Object}
         * @property {string} [destination] SendRequest destination.
         * @property {number|Long} [sendId] SendRequest sendId.
         * @property {Uint8Array} [body] SendRequest body.
         * @property {number|Long} [receiptId] SendRequest receiptId.
         */

        /**
         * Constructs a new SendRequest.
         * @exports stomp.SendRequest
         * @constructor
         * @param {stomp.SendRequest$Properties=} [properties] Properties to set
         */
        function SendRequest(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SendRequest destination.
         * @type {string}
         */
        SendRequest.prototype.destination = "";

        /**
         * SendRequest sendId.
         * @type {number|Long}
         */
        SendRequest.prototype.sendId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SendRequest body.
         * @type {Uint8Array}
         */
        SendRequest.prototype.body = $util.newBuffer([]);

        /**
         * SendRequest receiptId.
         * @type {number|Long}
         */
        SendRequest.prototype.receiptId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new SendRequest instance using the specified properties.
         * @param {stomp.SendRequest$Properties=} [properties] Properties to set
         * @returns {stomp.SendRequest} SendRequest instance
         */
        SendRequest.create = function create(properties) {
            return new SendRequest(properties);
        };

        /**
         * Encodes the specified SendRequest message. Does not implicitly {@link stomp.SendRequest.verify|verify} messages.
         * @param {stomp.SendRequest$Properties} message SendRequest message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SendRequest.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.destination != null && message.hasOwnProperty("destination"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.destination);
            if (message.sendId != null && message.hasOwnProperty("sendId"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.sendId);
            if (message.body != null && message.hasOwnProperty("body"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.body);
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                writer.uint32(/* id 4, wireType 0 =*/32).uint64(message.receiptId);
            return writer;
        };

        /**
         * Decodes a SendRequest message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.SendRequest} SendRequest
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SendRequest.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.SendRequest();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.destination = reader.string();
                    break;
                case 2:
                    message.sendId = reader.uint64();
                    break;
                case 3:
                    message.body = reader.bytes();
                    break;
                case 4:
                    message.receiptId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a SendRequest message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        SendRequest.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.destination != null && message.hasOwnProperty("destination"))
                if (!$util.isString(message.destination))
                    return "destination: string expected";
            if (message.sendId != null && message.hasOwnProperty("sendId"))
                if (!$util.isInteger(message.sendId) && !(message.sendId && $util.isInteger(message.sendId.low) && $util.isInteger(message.sendId.high)))
                    return "sendId: integer|Long expected";
            if (message.body != null && message.hasOwnProperty("body"))
                if (!(message.body && typeof message.body.length === "number" || $util.isString(message.body)))
                    return "body: buffer expected";
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (!$util.isInteger(message.receiptId) && !(message.receiptId && $util.isInteger(message.receiptId.low) && $util.isInteger(message.receiptId.high)))
                    return "receiptId: integer|Long expected";
            return null;
        };

        /**
         * Creates a SendRequest message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.SendRequest} SendRequest
         */
        SendRequest.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.SendRequest)
                return object;
            let message = new $root.stomp.SendRequest();
            if (object.destination != null)
                message.destination = String(object.destination);
            if (object.sendId != null)
                if ($util.Long)
                    (message.sendId = $util.Long.fromValue(object.sendId)).unsigned = true;
                else if (typeof object.sendId === "string")
                    message.sendId = parseInt(object.sendId, 10);
                else if (typeof object.sendId === "number")
                    message.sendId = object.sendId;
                else if (typeof object.sendId === "object")
                    message.sendId = new $util.LongBits(object.sendId.low >>> 0, object.sendId.high >>> 0).toNumber(true);
            if (object.body != null)
                if (typeof object.body === "string")
                    $util.base64.decode(object.body, message.body = $util.newBuffer($util.base64.length(object.body)), 0);
                else if (object.body.length)
                    message.body = object.body;
            if (object.receiptId != null)
                if ($util.Long)
                    (message.receiptId = $util.Long.fromValue(object.receiptId)).unsigned = true;
                else if (typeof object.receiptId === "string")
                    message.receiptId = parseInt(object.receiptId, 10);
                else if (typeof object.receiptId === "number")
                    message.receiptId = object.receiptId;
                else if (typeof object.receiptId === "object")
                    message.receiptId = new $util.LongBits(object.receiptId.low >>> 0, object.receiptId.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a SendRequest message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.SendRequest.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.SendRequest} SendRequest
         */
        SendRequest.from = SendRequest.fromObject;

        /**
         * Creates a plain object from a SendRequest message. Also converts values to other types if specified.
         * @param {stomp.SendRequest} message SendRequest
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendRequest.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.destination = "";
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.sendId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.sendId = options.longs === String ? "0" : 0;
                object.body = options.bytes === String ? "" : [];
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.receiptId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiptId = options.longs === String ? "0" : 0;
            }
            if (message.destination != null && message.hasOwnProperty("destination"))
                object.destination = message.destination;
            if (message.sendId != null && message.hasOwnProperty("sendId"))
                if (typeof message.sendId === "number")
                    object.sendId = options.longs === String ? String(message.sendId) : message.sendId;
                else
                    object.sendId = options.longs === String ? $util.Long.prototype.toString.call(message.sendId) : options.longs === Number ? new $util.LongBits(message.sendId.low >>> 0, message.sendId.high >>> 0).toNumber(true) : message.sendId;
            if (message.body != null && message.hasOwnProperty("body"))
                object.body = options.bytes === String ? $util.base64.encode(message.body, 0, message.body.length) : options.bytes === Array ? Array.prototype.slice.call(message.body) : message.body;
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (typeof message.receiptId === "number")
                    object.receiptId = options.longs === String ? String(message.receiptId) : message.receiptId;
                else
                    object.receiptId = options.longs === String ? $util.Long.prototype.toString.call(message.receiptId) : options.longs === Number ? new $util.LongBits(message.receiptId.low >>> 0, message.receiptId.high >>> 0).toNumber(true) : message.receiptId;
            return object;
        };

        /**
         * Creates a plain object from this SendRequest message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SendRequest.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this SendRequest to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        SendRequest.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SendRequest;
    })();

    stomp.RequestFrame = (function() {

        /**
         * Properties of a RequestFrame.
         * @typedef stomp.RequestFrame$Properties
         * @type {Object}
         * @property {stomp.ConnectRequest$Properties} [connect] RequestFrame connect.
         * @property {stomp.DisconnectRequest$Properties} [disconnect] RequestFrame disconnect.
         * @property {stomp.SubscribeRequest$Properties} [subscribe] RequestFrame subscribe.
         * @property {stomp.UnsubscribeRequest$Properties} [unsubscribe] RequestFrame unsubscribe.
         * @property {stomp.ThrottleRequest$Properties} [throttle] RequestFrame throttle.
         * @property {stomp.SendRequest$Properties} [send] RequestFrame send.
         * @property {stomp.Heartbeat$Properties} [heartbeat] RequestFrame heartbeat.
         */

        /**
         * Constructs a new RequestFrame.
         * @exports stomp.RequestFrame
         * @constructor
         * @param {stomp.RequestFrame$Properties=} [properties] Properties to set
         */
        function RequestFrame(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * RequestFrame connect.
         * @type {(stomp.ConnectRequest$Properties|null)}
         */
        RequestFrame.prototype.connect = null;

        /**
         * RequestFrame disconnect.
         * @type {(stomp.DisconnectRequest$Properties|null)}
         */
        RequestFrame.prototype.disconnect = null;

        /**
         * RequestFrame subscribe.
         * @type {(stomp.SubscribeRequest$Properties|null)}
         */
        RequestFrame.prototype.subscribe = null;

        /**
         * RequestFrame unsubscribe.
         * @type {(stomp.UnsubscribeRequest$Properties|null)}
         */
        RequestFrame.prototype.unsubscribe = null;

        /**
         * RequestFrame throttle.
         * @type {(stomp.ThrottleRequest$Properties|null)}
         */
        RequestFrame.prototype.throttle = null;

        /**
         * RequestFrame send.
         * @type {(stomp.SendRequest$Properties|null)}
         */
        RequestFrame.prototype.send = null;

        /**
         * RequestFrame heartbeat.
         * @type {(stomp.Heartbeat$Properties|null)}
         */
        RequestFrame.prototype.heartbeat = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * RequestFrame request.
         * @name stomp.RequestFrame#request
         * @type {string|undefined}
         */
        Object.defineProperty(RequestFrame.prototype, "request", {
            get: $util.oneOfGetter($oneOfFields = ["connect", "disconnect", "subscribe", "unsubscribe", "throttle", "send", "heartbeat"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new RequestFrame instance using the specified properties.
         * @param {stomp.RequestFrame$Properties=} [properties] Properties to set
         * @returns {stomp.RequestFrame} RequestFrame instance
         */
        RequestFrame.create = function create(properties) {
            return new RequestFrame(properties);
        };

        /**
         * Encodes the specified RequestFrame message. Does not implicitly {@link stomp.RequestFrame.verify|verify} messages.
         * @param {stomp.RequestFrame$Properties} message RequestFrame message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        RequestFrame.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.connect != null && message.hasOwnProperty("connect"))
                $root.stomp.ConnectRequest.encode(message.connect, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.disconnect != null && message.hasOwnProperty("disconnect"))
                $root.stomp.DisconnectRequest.encode(message.disconnect, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.subscribe != null && message.hasOwnProperty("subscribe"))
                $root.stomp.SubscribeRequest.encode(message.subscribe, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.unsubscribe != null && message.hasOwnProperty("unsubscribe"))
                $root.stomp.UnsubscribeRequest.encode(message.unsubscribe, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.throttle != null && message.hasOwnProperty("throttle"))
                $root.stomp.ThrottleRequest.encode(message.throttle, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.send != null && message.hasOwnProperty("send"))
                $root.stomp.SendRequest.encode(message.send, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.heartbeat != null && message.hasOwnProperty("heartbeat"))
                $root.stomp.Heartbeat.encode(message.heartbeat, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a RequestFrame message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.RequestFrame} RequestFrame
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        RequestFrame.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.RequestFrame();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.connect = $root.stomp.ConnectRequest.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.disconnect = $root.stomp.DisconnectRequest.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.subscribe = $root.stomp.SubscribeRequest.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.unsubscribe = $root.stomp.UnsubscribeRequest.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.throttle = $root.stomp.ThrottleRequest.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.send = $root.stomp.SendRequest.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.heartbeat = $root.stomp.Heartbeat.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a RequestFrame message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        RequestFrame.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.connect != null && message.hasOwnProperty("connect")) {
                properties.request = 1;
                let error = $root.stomp.ConnectRequest.verify(message.connect);
                if (error)
                    return "connect." + error;
            }
            if (message.disconnect != null && message.hasOwnProperty("disconnect")) {
                if (properties.request === 1)
                    return "request: multiple values";
                properties.request = 1;
                let error = $root.stomp.DisconnectRequest.verify(message.disconnect);
                if (error)
                    return "disconnect." + error;
            }
            if (message.subscribe != null && message.hasOwnProperty("subscribe")) {
                if (properties.request === 1)
                    return "request: multiple values";
                properties.request = 1;
                let error = $root.stomp.SubscribeRequest.verify(message.subscribe);
                if (error)
                    return "subscribe." + error;
            }
            if (message.unsubscribe != null && message.hasOwnProperty("unsubscribe")) {
                if (properties.request === 1)
                    return "request: multiple values";
                properties.request = 1;
                let error = $root.stomp.UnsubscribeRequest.verify(message.unsubscribe);
                if (error)
                    return "unsubscribe." + error;
            }
            if (message.throttle != null && message.hasOwnProperty("throttle")) {
                if (properties.request === 1)
                    return "request: multiple values";
                properties.request = 1;
                let error = $root.stomp.ThrottleRequest.verify(message.throttle);
                if (error)
                    return "throttle." + error;
            }
            if (message.send != null && message.hasOwnProperty("send")) {
                if (properties.request === 1)
                    return "request: multiple values";
                properties.request = 1;
                let error = $root.stomp.SendRequest.verify(message.send);
                if (error)
                    return "send." + error;
            }
            if (message.heartbeat != null && message.hasOwnProperty("heartbeat")) {
                if (properties.request === 1)
                    return "request: multiple values";
                properties.request = 1;
                let error = $root.stomp.Heartbeat.verify(message.heartbeat);
                if (error)
                    return "heartbeat." + error;
            }
            return null;
        };

        /**
         * Creates a RequestFrame message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.RequestFrame} RequestFrame
         */
        RequestFrame.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.RequestFrame)
                return object;
            let message = new $root.stomp.RequestFrame();
            if (object.connect != null) {
                if (typeof object.connect !== "object")
                    throw TypeError(".stomp.RequestFrame.connect: object expected");
                message.connect = $root.stomp.ConnectRequest.fromObject(object.connect);
            }
            if (object.disconnect != null) {
                if (typeof object.disconnect !== "object")
                    throw TypeError(".stomp.RequestFrame.disconnect: object expected");
                message.disconnect = $root.stomp.DisconnectRequest.fromObject(object.disconnect);
            }
            if (object.subscribe != null) {
                if (typeof object.subscribe !== "object")
                    throw TypeError(".stomp.RequestFrame.subscribe: object expected");
                message.subscribe = $root.stomp.SubscribeRequest.fromObject(object.subscribe);
            }
            if (object.unsubscribe != null) {
                if (typeof object.unsubscribe !== "object")
                    throw TypeError(".stomp.RequestFrame.unsubscribe: object expected");
                message.unsubscribe = $root.stomp.UnsubscribeRequest.fromObject(object.unsubscribe);
            }
            if (object.throttle != null) {
                if (typeof object.throttle !== "object")
                    throw TypeError(".stomp.RequestFrame.throttle: object expected");
                message.throttle = $root.stomp.ThrottleRequest.fromObject(object.throttle);
            }
            if (object.send != null) {
                if (typeof object.send !== "object")
                    throw TypeError(".stomp.RequestFrame.send: object expected");
                message.send = $root.stomp.SendRequest.fromObject(object.send);
            }
            if (object.heartbeat != null) {
                if (typeof object.heartbeat !== "object")
                    throw TypeError(".stomp.RequestFrame.heartbeat: object expected");
                message.heartbeat = $root.stomp.Heartbeat.fromObject(object.heartbeat);
            }
            return message;
        };

        /**
         * Creates a RequestFrame message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.RequestFrame.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.RequestFrame} RequestFrame
         */
        RequestFrame.from = RequestFrame.fromObject;

        /**
         * Creates a plain object from a RequestFrame message. Also converts values to other types if specified.
         * @param {stomp.RequestFrame} message RequestFrame
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestFrame.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.connect != null && message.hasOwnProperty("connect")) {
                object.connect = $root.stomp.ConnectRequest.toObject(message.connect, options);
                if (options.oneofs)
                    object.request = "connect";
            }
            if (message.disconnect != null && message.hasOwnProperty("disconnect")) {
                object.disconnect = $root.stomp.DisconnectRequest.toObject(message.disconnect, options);
                if (options.oneofs)
                    object.request = "disconnect";
            }
            if (message.subscribe != null && message.hasOwnProperty("subscribe")) {
                object.subscribe = $root.stomp.SubscribeRequest.toObject(message.subscribe, options);
                if (options.oneofs)
                    object.request = "subscribe";
            }
            if (message.unsubscribe != null && message.hasOwnProperty("unsubscribe")) {
                object.unsubscribe = $root.stomp.UnsubscribeRequest.toObject(message.unsubscribe, options);
                if (options.oneofs)
                    object.request = "unsubscribe";
            }
            if (message.throttle != null && message.hasOwnProperty("throttle")) {
                object.throttle = $root.stomp.ThrottleRequest.toObject(message.throttle, options);
                if (options.oneofs)
                    object.request = "throttle";
            }
            if (message.send != null && message.hasOwnProperty("send")) {
                object.send = $root.stomp.SendRequest.toObject(message.send, options);
                if (options.oneofs)
                    object.request = "send";
            }
            if (message.heartbeat != null && message.hasOwnProperty("heartbeat")) {
                object.heartbeat = $root.stomp.Heartbeat.toObject(message.heartbeat, options);
                if (options.oneofs)
                    object.request = "heartbeat";
            }
            return object;
        };

        /**
         * Creates a plain object from this RequestFrame message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        RequestFrame.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this RequestFrame to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        RequestFrame.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return RequestFrame;
    })();

    stomp.ConnectedResponse = (function() {

        /**
         * Properties of a ConnectedResponse.
         * @typedef stomp.ConnectedResponse$Properties
         * @type {Object}
         * @property {string} [version] ConnectedResponse version.
         */

        /**
         * Constructs a new ConnectedResponse.
         * @exports stomp.ConnectedResponse
         * @constructor
         * @param {stomp.ConnectedResponse$Properties=} [properties] Properties to set
         */
        function ConnectedResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ConnectedResponse version.
         * @type {string}
         */
        ConnectedResponse.prototype.version = "";

        /**
         * Creates a new ConnectedResponse instance using the specified properties.
         * @param {stomp.ConnectedResponse$Properties=} [properties] Properties to set
         * @returns {stomp.ConnectedResponse} ConnectedResponse instance
         */
        ConnectedResponse.create = function create(properties) {
            return new ConnectedResponse(properties);
        };

        /**
         * Encodes the specified ConnectedResponse message. Does not implicitly {@link stomp.ConnectedResponse.verify|verify} messages.
         * @param {stomp.ConnectedResponse$Properties} message ConnectedResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ConnectedResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.version != null && message.hasOwnProperty("version"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.version);
            return writer;
        };

        /**
         * Decodes a ConnectedResponse message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.ConnectedResponse} ConnectedResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ConnectedResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.ConnectedResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.version = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a ConnectedResponse message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        ConnectedResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.version != null && message.hasOwnProperty("version"))
                if (!$util.isString(message.version))
                    return "version: string expected";
            return null;
        };

        /**
         * Creates a ConnectedResponse message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ConnectedResponse} ConnectedResponse
         */
        ConnectedResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.ConnectedResponse)
                return object;
            let message = new $root.stomp.ConnectedResponse();
            if (object.version != null)
                message.version = String(object.version);
            return message;
        };

        /**
         * Creates a ConnectedResponse message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.ConnectedResponse.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ConnectedResponse} ConnectedResponse
         */
        ConnectedResponse.from = ConnectedResponse.fromObject;

        /**
         * Creates a plain object from a ConnectedResponse message. Also converts values to other types if specified.
         * @param {stomp.ConnectedResponse} message ConnectedResponse
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConnectedResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                object.version = "";
            if (message.version != null && message.hasOwnProperty("version"))
                object.version = message.version;
            return object;
        };

        /**
         * Creates a plain object from this ConnectedResponse message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ConnectedResponse.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this ConnectedResponse to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        ConnectedResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ConnectedResponse;
    })();

    stomp.MessageResponse = (function() {

        /**
         * Properties of a MessageResponse.
         * @typedef stomp.MessageResponse$Properties
         * @type {Object}
         * @property {number|Long} [subscriptionId] MessageResponse subscriptionId.
         * @property {number|Long} [messageId] MessageResponse messageId.
         * @property {Uint8Array} [body] MessageResponse body.
         */

        /**
         * Constructs a new MessageResponse.
         * @exports stomp.MessageResponse
         * @constructor
         * @param {stomp.MessageResponse$Properties=} [properties] Properties to set
         */
        function MessageResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageResponse subscriptionId.
         * @type {number|Long}
         */
        MessageResponse.prototype.subscriptionId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * MessageResponse messageId.
         * @type {number|Long}
         */
        MessageResponse.prototype.messageId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * MessageResponse body.
         * @type {Uint8Array}
         */
        MessageResponse.prototype.body = $util.newBuffer([]);

        /**
         * Creates a new MessageResponse instance using the specified properties.
         * @param {stomp.MessageResponse$Properties=} [properties] Properties to set
         * @returns {stomp.MessageResponse} MessageResponse instance
         */
        MessageResponse.create = function create(properties) {
            return new MessageResponse(properties);
        };

        /**
         * Encodes the specified MessageResponse message. Does not implicitly {@link stomp.MessageResponse.verify|verify} messages.
         * @param {stomp.MessageResponse$Properties} message MessageResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.subscriptionId);
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.messageId);
            if (message.body != null && message.hasOwnProperty("body"))
                writer.uint32(/* id 3, wireType 2 =*/26).bytes(message.body);
            return writer;
        };

        /**
         * Decodes a MessageResponse message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.MessageResponse} MessageResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.MessageResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.subscriptionId = reader.uint64();
                    break;
                case 2:
                    message.messageId = reader.uint64();
                    break;
                case 3:
                    message.body = reader.bytes();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a MessageResponse message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        MessageResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (!$util.isInteger(message.subscriptionId) && !(message.subscriptionId && $util.isInteger(message.subscriptionId.low) && $util.isInteger(message.subscriptionId.high)))
                    return "subscriptionId: integer|Long expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isInteger(message.messageId) && !(message.messageId && $util.isInteger(message.messageId.low) && $util.isInteger(message.messageId.high)))
                    return "messageId: integer|Long expected";
            if (message.body != null && message.hasOwnProperty("body"))
                if (!(message.body && typeof message.body.length === "number" || $util.isString(message.body)))
                    return "body: buffer expected";
            return null;
        };

        /**
         * Creates a MessageResponse message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.MessageResponse} MessageResponse
         */
        MessageResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.MessageResponse)
                return object;
            let message = new $root.stomp.MessageResponse();
            if (object.subscriptionId != null)
                if ($util.Long)
                    (message.subscriptionId = $util.Long.fromValue(object.subscriptionId)).unsigned = true;
                else if (typeof object.subscriptionId === "string")
                    message.subscriptionId = parseInt(object.subscriptionId, 10);
                else if (typeof object.subscriptionId === "number")
                    message.subscriptionId = object.subscriptionId;
                else if (typeof object.subscriptionId === "object")
                    message.subscriptionId = new $util.LongBits(object.subscriptionId.low >>> 0, object.subscriptionId.high >>> 0).toNumber(true);
            if (object.messageId != null)
                if ($util.Long)
                    (message.messageId = $util.Long.fromValue(object.messageId)).unsigned = true;
                else if (typeof object.messageId === "string")
                    message.messageId = parseInt(object.messageId, 10);
                else if (typeof object.messageId === "number")
                    message.messageId = object.messageId;
                else if (typeof object.messageId === "object")
                    message.messageId = new $util.LongBits(object.messageId.low >>> 0, object.messageId.high >>> 0).toNumber(true);
            if (object.body != null)
                if (typeof object.body === "string")
                    $util.base64.decode(object.body, message.body = $util.newBuffer($util.base64.length(object.body)), 0);
                else if (object.body.length)
                    message.body = object.body;
            return message;
        };

        /**
         * Creates a MessageResponse message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.MessageResponse.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.MessageResponse} MessageResponse
         */
        MessageResponse.from = MessageResponse.fromObject;

        /**
         * Creates a plain object from a MessageResponse message. Also converts values to other types if specified.
         * @param {stomp.MessageResponse} message MessageResponse
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.subscriptionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.subscriptionId = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.messageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.messageId = options.longs === String ? "0" : 0;
                object.body = options.bytes === String ? "" : [];
            }
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (typeof message.subscriptionId === "number")
                    object.subscriptionId = options.longs === String ? String(message.subscriptionId) : message.subscriptionId;
                else
                    object.subscriptionId = options.longs === String ? $util.Long.prototype.toString.call(message.subscriptionId) : options.longs === Number ? new $util.LongBits(message.subscriptionId.low >>> 0, message.subscriptionId.high >>> 0).toNumber(true) : message.subscriptionId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (typeof message.messageId === "number")
                    object.messageId = options.longs === String ? String(message.messageId) : message.messageId;
                else
                    object.messageId = options.longs === String ? $util.Long.prototype.toString.call(message.messageId) : options.longs === Number ? new $util.LongBits(message.messageId.low >>> 0, message.messageId.high >>> 0).toNumber(true) : message.messageId;
            if (message.body != null && message.hasOwnProperty("body"))
                object.body = options.bytes === String ? $util.base64.encode(message.body, 0, message.body.length) : options.bytes === Array ? Array.prototype.slice.call(message.body) : message.body;
            return object;
        };

        /**
         * Creates a plain object from this MessageResponse message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageResponse.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this MessageResponse to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        MessageResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageResponse;
    })();

    stomp.MessageResponses = (function() {

        /**
         * Properties of a MessageResponses.
         * @typedef stomp.MessageResponses$Properties
         * @type {Object}
         * @property {Array.<stomp.MessageResponse$Properties>} [message] MessageResponses message.
         */

        /**
         * Constructs a new MessageResponses.
         * @exports stomp.MessageResponses
         * @constructor
         * @param {stomp.MessageResponses$Properties=} [properties] Properties to set
         */
        function MessageResponses(properties) {
            this.message = [];
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * MessageResponses message.
         * @type {Array.<stomp.MessageResponse$Properties>}
         */
        MessageResponses.prototype.message = $util.emptyArray;

        /**
         * Creates a new MessageResponses instance using the specified properties.
         * @param {stomp.MessageResponses$Properties=} [properties] Properties to set
         * @returns {stomp.MessageResponses} MessageResponses instance
         */
        MessageResponses.create = function create(properties) {
            return new MessageResponses(properties);
        };

        /**
         * Encodes the specified MessageResponses message. Does not implicitly {@link stomp.MessageResponses.verify|verify} messages.
         * @param {stomp.MessageResponses$Properties} message MessageResponses message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        MessageResponses.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.message != null && message.message.length)
                for (let i = 0; i < message.message.length; ++i)
                    $root.stomp.MessageResponse.encode(message.message[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a MessageResponses message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.MessageResponses} MessageResponses
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        MessageResponses.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.MessageResponses();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    if (!(message.message && message.message.length))
                        message.message = [];
                    message.message.push($root.stomp.MessageResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a MessageResponses message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        MessageResponses.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.message != null && message.hasOwnProperty("message")) {
                if (!Array.isArray(message.message))
                    return "message: array expected";
                for (let i = 0; i < message.message.length; ++i) {
                    let error = $root.stomp.MessageResponse.verify(message.message[i]);
                    if (error)
                        return "message." + error;
                }
            }
            return null;
        };

        /**
         * Creates a MessageResponses message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.MessageResponses} MessageResponses
         */
        MessageResponses.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.MessageResponses)
                return object;
            let message = new $root.stomp.MessageResponses();
            if (object.message) {
                if (!Array.isArray(object.message))
                    throw TypeError(".stomp.MessageResponses.message: array expected");
                message.message = [];
                for (let i = 0; i < object.message.length; ++i) {
                    if (typeof object.message[i] !== "object")
                        throw TypeError(".stomp.MessageResponses.message: object expected");
                    message.message[i] = $root.stomp.MessageResponse.fromObject(object.message[i]);
                }
            }
            return message;
        };

        /**
         * Creates a MessageResponses message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.MessageResponses.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.MessageResponses} MessageResponses
         */
        MessageResponses.from = MessageResponses.fromObject;

        /**
         * Creates a plain object from a MessageResponses message. Also converts values to other types if specified.
         * @param {stomp.MessageResponses} message MessageResponses
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageResponses.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.arrays || options.defaults)
                object.message = [];
            if (message.message && message.message.length) {
                object.message = [];
                for (let j = 0; j < message.message.length; ++j)
                    object.message[j] = $root.stomp.MessageResponse.toObject(message.message[j], options);
            }
            return object;
        };

        /**
         * Creates a plain object from this MessageResponses message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        MessageResponses.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this MessageResponses to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        MessageResponses.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return MessageResponses;
    })();

    stomp.ReceiptResponse = (function() {

        /**
         * Properties of a ReceiptResponse.
         * @typedef stomp.ReceiptResponse$Properties
         * @type {Object}
         * @property {number|Long} [receiptId] ReceiptResponse receiptId.
         */

        /**
         * Constructs a new ReceiptResponse.
         * @exports stomp.ReceiptResponse
         * @constructor
         * @param {stomp.ReceiptResponse$Properties=} [properties] Properties to set
         */
        function ReceiptResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ReceiptResponse receiptId.
         * @type {number|Long}
         */
        ReceiptResponse.prototype.receiptId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * Creates a new ReceiptResponse instance using the specified properties.
         * @param {stomp.ReceiptResponse$Properties=} [properties] Properties to set
         * @returns {stomp.ReceiptResponse} ReceiptResponse instance
         */
        ReceiptResponse.create = function create(properties) {
            return new ReceiptResponse(properties);
        };

        /**
         * Encodes the specified ReceiptResponse message. Does not implicitly {@link stomp.ReceiptResponse.verify|verify} messages.
         * @param {stomp.ReceiptResponse$Properties} message ReceiptResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ReceiptResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.receiptId);
            return writer;
        };

        /**
         * Decodes a ReceiptResponse message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.ReceiptResponse} ReceiptResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ReceiptResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.ReceiptResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.receiptId = reader.uint64();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a ReceiptResponse message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        ReceiptResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (!$util.isInteger(message.receiptId) && !(message.receiptId && $util.isInteger(message.receiptId.low) && $util.isInteger(message.receiptId.high)))
                    return "receiptId: integer|Long expected";
            return null;
        };

        /**
         * Creates a ReceiptResponse message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ReceiptResponse} ReceiptResponse
         */
        ReceiptResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.ReceiptResponse)
                return object;
            let message = new $root.stomp.ReceiptResponse();
            if (object.receiptId != null)
                if ($util.Long)
                    (message.receiptId = $util.Long.fromValue(object.receiptId)).unsigned = true;
                else if (typeof object.receiptId === "string")
                    message.receiptId = parseInt(object.receiptId, 10);
                else if (typeof object.receiptId === "number")
                    message.receiptId = object.receiptId;
                else if (typeof object.receiptId === "object")
                    message.receiptId = new $util.LongBits(object.receiptId.low >>> 0, object.receiptId.high >>> 0).toNumber(true);
            return message;
        };

        /**
         * Creates a ReceiptResponse message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.ReceiptResponse.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ReceiptResponse} ReceiptResponse
         */
        ReceiptResponse.from = ReceiptResponse.fromObject;

        /**
         * Creates a plain object from a ReceiptResponse message. Also converts values to other types if specified.
         * @param {stomp.ReceiptResponse} message ReceiptResponse
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReceiptResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults)
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.receiptId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.receiptId = options.longs === String ? "0" : 0;
            if (message.receiptId != null && message.hasOwnProperty("receiptId"))
                if (typeof message.receiptId === "number")
                    object.receiptId = options.longs === String ? String(message.receiptId) : message.receiptId;
                else
                    object.receiptId = options.longs === String ? $util.Long.prototype.toString.call(message.receiptId) : options.longs === Number ? new $util.LongBits(message.receiptId.low >>> 0, message.receiptId.high >>> 0).toNumber(true) : message.receiptId;
            return object;
        };

        /**
         * Creates a plain object from this ReceiptResponse message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ReceiptResponse.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this ReceiptResponse to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        ReceiptResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ReceiptResponse;
    })();

    stomp.ServerErrorResponse = (function() {

        /**
         * Properties of a ServerErrorResponse.
         * @typedef stomp.ServerErrorResponse$Properties
         * @type {Object}
         * @property {string} [message] ServerErrorResponse message.
         * @property {string} [details] ServerErrorResponse details.
         */

        /**
         * Constructs a new ServerErrorResponse.
         * @exports stomp.ServerErrorResponse
         * @constructor
         * @param {stomp.ServerErrorResponse$Properties=} [properties] Properties to set
         */
        function ServerErrorResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ServerErrorResponse message.
         * @type {string}
         */
        ServerErrorResponse.prototype.message = "";

        /**
         * ServerErrorResponse details.
         * @type {string}
         */
        ServerErrorResponse.prototype.details = "";

        /**
         * Creates a new ServerErrorResponse instance using the specified properties.
         * @param {stomp.ServerErrorResponse$Properties=} [properties] Properties to set
         * @returns {stomp.ServerErrorResponse} ServerErrorResponse instance
         */
        ServerErrorResponse.create = function create(properties) {
            return new ServerErrorResponse(properties);
        };

        /**
         * Encodes the specified ServerErrorResponse message. Does not implicitly {@link stomp.ServerErrorResponse.verify|verify} messages.
         * @param {stomp.ServerErrorResponse$Properties} message ServerErrorResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ServerErrorResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.message != null && message.hasOwnProperty("message"))
                writer.uint32(/* id 1, wireType 2 =*/10).string(message.message);
            if (message.details != null && message.hasOwnProperty("details"))
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.details);
            return writer;
        };

        /**
         * Decodes a ServerErrorResponse message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.ServerErrorResponse} ServerErrorResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ServerErrorResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.ServerErrorResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.message = reader.string();
                    break;
                case 2:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a ServerErrorResponse message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        ServerErrorResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.details != null && message.hasOwnProperty("details"))
                if (!$util.isString(message.details))
                    return "details: string expected";
            return null;
        };

        /**
         * Creates a ServerErrorResponse message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ServerErrorResponse} ServerErrorResponse
         */
        ServerErrorResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.ServerErrorResponse)
                return object;
            let message = new $root.stomp.ServerErrorResponse();
            if (object.message != null)
                message.message = String(object.message);
            if (object.details != null)
                message.details = String(object.details);
            return message;
        };

        /**
         * Creates a ServerErrorResponse message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.ServerErrorResponse.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ServerErrorResponse} ServerErrorResponse
         */
        ServerErrorResponse.from = ServerErrorResponse.fromObject;

        /**
         * Creates a plain object from a ServerErrorResponse message. Also converts values to other types if specified.
         * @param {stomp.ServerErrorResponse} message ServerErrorResponse
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServerErrorResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                object.message = "";
                object.details = "";
            }
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.details != null && message.hasOwnProperty("details"))
                object.details = message.details;
            return object;
        };

        /**
         * Creates a plain object from this ServerErrorResponse message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ServerErrorResponse.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this ServerErrorResponse to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        ServerErrorResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ServerErrorResponse;
    })();

    stomp.SubscriptionErrorResponse = (function() {

        /**
         * Properties of a SubscriptionErrorResponse.
         * @typedef stomp.SubscriptionErrorResponse$Properties
         * @type {Object}
         * @property {number|Long} [subscriptionId] SubscriptionErrorResponse subscriptionId.
         * @property {number|Long} [messageId] SubscriptionErrorResponse messageId.
         * @property {string} [message] SubscriptionErrorResponse message.
         * @property {string} [details] SubscriptionErrorResponse details.
         */

        /**
         * Constructs a new SubscriptionErrorResponse.
         * @exports stomp.SubscriptionErrorResponse
         * @constructor
         * @param {stomp.SubscriptionErrorResponse$Properties=} [properties] Properties to set
         */
        function SubscriptionErrorResponse(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * SubscriptionErrorResponse subscriptionId.
         * @type {number|Long}
         */
        SubscriptionErrorResponse.prototype.subscriptionId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SubscriptionErrorResponse messageId.
         * @type {number|Long}
         */
        SubscriptionErrorResponse.prototype.messageId = $util.Long ? $util.Long.fromBits(0,0,true) : 0;

        /**
         * SubscriptionErrorResponse message.
         * @type {string}
         */
        SubscriptionErrorResponse.prototype.message = "";

        /**
         * SubscriptionErrorResponse details.
         * @type {string}
         */
        SubscriptionErrorResponse.prototype.details = "";

        /**
         * Creates a new SubscriptionErrorResponse instance using the specified properties.
         * @param {stomp.SubscriptionErrorResponse$Properties=} [properties] Properties to set
         * @returns {stomp.SubscriptionErrorResponse} SubscriptionErrorResponse instance
         */
        SubscriptionErrorResponse.create = function create(properties) {
            return new SubscriptionErrorResponse(properties);
        };

        /**
         * Encodes the specified SubscriptionErrorResponse message. Does not implicitly {@link stomp.SubscriptionErrorResponse.verify|verify} messages.
         * @param {stomp.SubscriptionErrorResponse$Properties} message SubscriptionErrorResponse message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        SubscriptionErrorResponse.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                writer.uint32(/* id 1, wireType 0 =*/8).uint64(message.subscriptionId);
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                writer.uint32(/* id 2, wireType 0 =*/16).uint64(message.messageId);
            if (message.message != null && message.hasOwnProperty("message"))
                writer.uint32(/* id 3, wireType 2 =*/26).string(message.message);
            if (message.details != null && message.hasOwnProperty("details"))
                writer.uint32(/* id 4, wireType 2 =*/34).string(message.details);
            return writer;
        };

        /**
         * Decodes a SubscriptionErrorResponse message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.SubscriptionErrorResponse} SubscriptionErrorResponse
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        SubscriptionErrorResponse.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.SubscriptionErrorResponse();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.subscriptionId = reader.uint64();
                    break;
                case 2:
                    message.messageId = reader.uint64();
                    break;
                case 3:
                    message.message = reader.string();
                    break;
                case 4:
                    message.details = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a SubscriptionErrorResponse message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        SubscriptionErrorResponse.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (!$util.isInteger(message.subscriptionId) && !(message.subscriptionId && $util.isInteger(message.subscriptionId.low) && $util.isInteger(message.subscriptionId.high)))
                    return "subscriptionId: integer|Long expected";
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (!$util.isInteger(message.messageId) && !(message.messageId && $util.isInteger(message.messageId.low) && $util.isInteger(message.messageId.high)))
                    return "messageId: integer|Long expected";
            if (message.message != null && message.hasOwnProperty("message"))
                if (!$util.isString(message.message))
                    return "message: string expected";
            if (message.details != null && message.hasOwnProperty("details"))
                if (!$util.isString(message.details))
                    return "details: string expected";
            return null;
        };

        /**
         * Creates a SubscriptionErrorResponse message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.SubscriptionErrorResponse} SubscriptionErrorResponse
         */
        SubscriptionErrorResponse.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.SubscriptionErrorResponse)
                return object;
            let message = new $root.stomp.SubscriptionErrorResponse();
            if (object.subscriptionId != null)
                if ($util.Long)
                    (message.subscriptionId = $util.Long.fromValue(object.subscriptionId)).unsigned = true;
                else if (typeof object.subscriptionId === "string")
                    message.subscriptionId = parseInt(object.subscriptionId, 10);
                else if (typeof object.subscriptionId === "number")
                    message.subscriptionId = object.subscriptionId;
                else if (typeof object.subscriptionId === "object")
                    message.subscriptionId = new $util.LongBits(object.subscriptionId.low >>> 0, object.subscriptionId.high >>> 0).toNumber(true);
            if (object.messageId != null)
                if ($util.Long)
                    (message.messageId = $util.Long.fromValue(object.messageId)).unsigned = true;
                else if (typeof object.messageId === "string")
                    message.messageId = parseInt(object.messageId, 10);
                else if (typeof object.messageId === "number")
                    message.messageId = object.messageId;
                else if (typeof object.messageId === "object")
                    message.messageId = new $util.LongBits(object.messageId.low >>> 0, object.messageId.high >>> 0).toNumber(true);
            if (object.message != null)
                message.message = String(object.message);
            if (object.details != null)
                message.details = String(object.details);
            return message;
        };

        /**
         * Creates a SubscriptionErrorResponse message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.SubscriptionErrorResponse.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.SubscriptionErrorResponse} SubscriptionErrorResponse
         */
        SubscriptionErrorResponse.from = SubscriptionErrorResponse.fromObject;

        /**
         * Creates a plain object from a SubscriptionErrorResponse message. Also converts values to other types if specified.
         * @param {stomp.SubscriptionErrorResponse} message SubscriptionErrorResponse
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SubscriptionErrorResponse.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (options.defaults) {
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.subscriptionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.subscriptionId = options.longs === String ? "0" : 0;
                if ($util.Long) {
                    let long = new $util.Long(0, 0, true);
                    object.messageId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
                } else
                    object.messageId = options.longs === String ? "0" : 0;
                object.message = "";
                object.details = "";
            }
            if (message.subscriptionId != null && message.hasOwnProperty("subscriptionId"))
                if (typeof message.subscriptionId === "number")
                    object.subscriptionId = options.longs === String ? String(message.subscriptionId) : message.subscriptionId;
                else
                    object.subscriptionId = options.longs === String ? $util.Long.prototype.toString.call(message.subscriptionId) : options.longs === Number ? new $util.LongBits(message.subscriptionId.low >>> 0, message.subscriptionId.high >>> 0).toNumber(true) : message.subscriptionId;
            if (message.messageId != null && message.hasOwnProperty("messageId"))
                if (typeof message.messageId === "number")
                    object.messageId = options.longs === String ? String(message.messageId) : message.messageId;
                else
                    object.messageId = options.longs === String ? $util.Long.prototype.toString.call(message.messageId) : options.longs === Number ? new $util.LongBits(message.messageId.low >>> 0, message.messageId.high >>> 0).toNumber(true) : message.messageId;
            if (message.message != null && message.hasOwnProperty("message"))
                object.message = message.message;
            if (message.details != null && message.hasOwnProperty("details"))
                object.details = message.details;
            return object;
        };

        /**
         * Creates a plain object from this SubscriptionErrorResponse message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        SubscriptionErrorResponse.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this SubscriptionErrorResponse to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        SubscriptionErrorResponse.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return SubscriptionErrorResponse;
    })();

    stomp.ResponseFrame = (function() {

        /**
         * Properties of a ResponseFrame.
         * @typedef stomp.ResponseFrame$Properties
         * @type {Object}
         * @property {stomp.ConnectedResponse$Properties} [connected] ResponseFrame connected.
         * @property {stomp.MessageResponse$Properties} [singleMessage] ResponseFrame singleMessage.
         * @property {stomp.MessageResponses$Properties} [batchMessages] ResponseFrame batchMessages.
         * @property {stomp.ReceiptResponse$Properties} [receipt] ResponseFrame receipt.
         * @property {stomp.ServerErrorResponse$Properties} [serverError] ResponseFrame serverError.
         * @property {stomp.SubscriptionErrorResponse$Properties} [subscriptionError] ResponseFrame subscriptionError.
         * @property {stomp.Heartbeat$Properties} [heartbeat] ResponseFrame heartbeat.
         */

        /**
         * Constructs a new ResponseFrame.
         * @exports stomp.ResponseFrame
         * @constructor
         * @param {stomp.ResponseFrame$Properties=} [properties] Properties to set
         */
        function ResponseFrame(properties) {
            if (properties)
                for (let keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                    if (properties[keys[i]] != null)
                        this[keys[i]] = properties[keys[i]];
        }

        /**
         * ResponseFrame connected.
         * @type {(stomp.ConnectedResponse$Properties|null)}
         */
        ResponseFrame.prototype.connected = null;

        /**
         * ResponseFrame singleMessage.
         * @type {(stomp.MessageResponse$Properties|null)}
         */
        ResponseFrame.prototype.singleMessage = null;

        /**
         * ResponseFrame batchMessages.
         * @type {(stomp.MessageResponses$Properties|null)}
         */
        ResponseFrame.prototype.batchMessages = null;

        /**
         * ResponseFrame receipt.
         * @type {(stomp.ReceiptResponse$Properties|null)}
         */
        ResponseFrame.prototype.receipt = null;

        /**
         * ResponseFrame serverError.
         * @type {(stomp.ServerErrorResponse$Properties|null)}
         */
        ResponseFrame.prototype.serverError = null;

        /**
         * ResponseFrame subscriptionError.
         * @type {(stomp.SubscriptionErrorResponse$Properties|null)}
         */
        ResponseFrame.prototype.subscriptionError = null;

        /**
         * ResponseFrame heartbeat.
         * @type {(stomp.Heartbeat$Properties|null)}
         */
        ResponseFrame.prototype.heartbeat = null;

        // OneOf field names bound to virtual getters and setters
        let $oneOfFields;

        /**
         * ResponseFrame response.
         * @name stomp.ResponseFrame#response
         * @type {string|undefined}
         */
        Object.defineProperty(ResponseFrame.prototype, "response", {
            get: $util.oneOfGetter($oneOfFields = ["connected", "singleMessage", "batchMessages", "receipt", "serverError", "subscriptionError", "heartbeat"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Creates a new ResponseFrame instance using the specified properties.
         * @param {stomp.ResponseFrame$Properties=} [properties] Properties to set
         * @returns {stomp.ResponseFrame} ResponseFrame instance
         */
        ResponseFrame.create = function create(properties) {
            return new ResponseFrame(properties);
        };

        /**
         * Encodes the specified ResponseFrame message. Does not implicitly {@link stomp.ResponseFrame.verify|verify} messages.
         * @param {stomp.ResponseFrame$Properties} message ResponseFrame message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        ResponseFrame.encode = function encode(message, writer) {
            if (!writer)
                writer = $Writer.create();
            if (message.connected != null && message.hasOwnProperty("connected"))
                $root.stomp.ConnectedResponse.encode(message.connected, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
            if (message.singleMessage != null && message.hasOwnProperty("singleMessage"))
                $root.stomp.MessageResponse.encode(message.singleMessage, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
            if (message.batchMessages != null && message.hasOwnProperty("batchMessages"))
                $root.stomp.MessageResponses.encode(message.batchMessages, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
            if (message.receipt != null && message.hasOwnProperty("receipt"))
                $root.stomp.ReceiptResponse.encode(message.receipt, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
            if (message.serverError != null && message.hasOwnProperty("serverError"))
                $root.stomp.ServerErrorResponse.encode(message.serverError, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
            if (message.subscriptionError != null && message.hasOwnProperty("subscriptionError"))
                $root.stomp.SubscriptionErrorResponse.encode(message.subscriptionError, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
            if (message.heartbeat != null && message.hasOwnProperty("heartbeat"))
                $root.stomp.Heartbeat.encode(message.heartbeat, writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
            return writer;
        };

        /**
         * Decodes a ResponseFrame message from the specified reader or buffer.
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @param {number} [length] Message length if known beforehand
         * @returns {stomp.ResponseFrame} ResponseFrame
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        ResponseFrame.decode = function decode(reader, length) {
            if (!(reader instanceof $Reader))
                reader = $Reader.create(reader);
            let end = length === undefined ? reader.len : reader.pos + length, message = new $root.stomp.ResponseFrame();
            while (reader.pos < end) {
                let tag = reader.uint32();
                switch (tag >>> 3) {
                case 1:
                    message.connected = $root.stomp.ConnectedResponse.decode(reader, reader.uint32());
                    break;
                case 2:
                    message.singleMessage = $root.stomp.MessageResponse.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.batchMessages = $root.stomp.MessageResponses.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.receipt = $root.stomp.ReceiptResponse.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.serverError = $root.stomp.ServerErrorResponse.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.subscriptionError = $root.stomp.SubscriptionErrorResponse.decode(reader, reader.uint32());
                    break;
                case 7:
                    message.heartbeat = $root.stomp.Heartbeat.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
                }
            }
            return message;
        };

        /**
         * Verifies a ResponseFrame message.
         * @param {Object.<string,*>} message Plain object to verify
         * @returns {?string} `null` if valid, otherwise the reason why it is not
         */
        ResponseFrame.verify = function verify(message) {
            if (typeof message !== "object" || message === null)
                return "object expected";
            let properties = {};
            if (message.connected != null && message.hasOwnProperty("connected")) {
                properties.response = 1;
                let error = $root.stomp.ConnectedResponse.verify(message.connected);
                if (error)
                    return "connected." + error;
            }
            if (message.singleMessage != null && message.hasOwnProperty("singleMessage")) {
                if (properties.response === 1)
                    return "response: multiple values";
                properties.response = 1;
                let error = $root.stomp.MessageResponse.verify(message.singleMessage);
                if (error)
                    return "singleMessage." + error;
            }
            if (message.batchMessages != null && message.hasOwnProperty("batchMessages")) {
                if (properties.response === 1)
                    return "response: multiple values";
                properties.response = 1;
                let error = $root.stomp.MessageResponses.verify(message.batchMessages);
                if (error)
                    return "batchMessages." + error;
            }
            if (message.receipt != null && message.hasOwnProperty("receipt")) {
                if (properties.response === 1)
                    return "response: multiple values";
                properties.response = 1;
                let error = $root.stomp.ReceiptResponse.verify(message.receipt);
                if (error)
                    return "receipt." + error;
            }
            if (message.serverError != null && message.hasOwnProperty("serverError")) {
                if (properties.response === 1)
                    return "response: multiple values";
                properties.response = 1;
                let error = $root.stomp.ServerErrorResponse.verify(message.serverError);
                if (error)
                    return "serverError." + error;
            }
            if (message.subscriptionError != null && message.hasOwnProperty("subscriptionError")) {
                if (properties.response === 1)
                    return "response: multiple values";
                properties.response = 1;
                let error = $root.stomp.SubscriptionErrorResponse.verify(message.subscriptionError);
                if (error)
                    return "subscriptionError." + error;
            }
            if (message.heartbeat != null && message.hasOwnProperty("heartbeat")) {
                if (properties.response === 1)
                    return "response: multiple values";
                properties.response = 1;
                let error = $root.stomp.Heartbeat.verify(message.heartbeat);
                if (error)
                    return "heartbeat." + error;
            }
            return null;
        };

        /**
         * Creates a ResponseFrame message from a plain object. Also converts values to their respective internal types.
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ResponseFrame} ResponseFrame
         */
        ResponseFrame.fromObject = function fromObject(object) {
            if (object instanceof $root.stomp.ResponseFrame)
                return object;
            let message = new $root.stomp.ResponseFrame();
            if (object.connected != null) {
                if (typeof object.connected !== "object")
                    throw TypeError(".stomp.ResponseFrame.connected: object expected");
                message.connected = $root.stomp.ConnectedResponse.fromObject(object.connected);
            }
            if (object.singleMessage != null) {
                if (typeof object.singleMessage !== "object")
                    throw TypeError(".stomp.ResponseFrame.singleMessage: object expected");
                message.singleMessage = $root.stomp.MessageResponse.fromObject(object.singleMessage);
            }
            if (object.batchMessages != null) {
                if (typeof object.batchMessages !== "object")
                    throw TypeError(".stomp.ResponseFrame.batchMessages: object expected");
                message.batchMessages = $root.stomp.MessageResponses.fromObject(object.batchMessages);
            }
            if (object.receipt != null) {
                if (typeof object.receipt !== "object")
                    throw TypeError(".stomp.ResponseFrame.receipt: object expected");
                message.receipt = $root.stomp.ReceiptResponse.fromObject(object.receipt);
            }
            if (object.serverError != null) {
                if (typeof object.serverError !== "object")
                    throw TypeError(".stomp.ResponseFrame.serverError: object expected");
                message.serverError = $root.stomp.ServerErrorResponse.fromObject(object.serverError);
            }
            if (object.subscriptionError != null) {
                if (typeof object.subscriptionError !== "object")
                    throw TypeError(".stomp.ResponseFrame.subscriptionError: object expected");
                message.subscriptionError = $root.stomp.SubscriptionErrorResponse.fromObject(object.subscriptionError);
            }
            if (object.heartbeat != null) {
                if (typeof object.heartbeat !== "object")
                    throw TypeError(".stomp.ResponseFrame.heartbeat: object expected");
                message.heartbeat = $root.stomp.Heartbeat.fromObject(object.heartbeat);
            }
            return message;
        };

        /**
         * Creates a ResponseFrame message from a plain object. Also converts values to their respective internal types.
         * This is an alias of {@link stomp.ResponseFrame.fromObject}.
         * @function
         * @param {Object.<string,*>} object Plain object
         * @returns {stomp.ResponseFrame} ResponseFrame
         */
        ResponseFrame.from = ResponseFrame.fromObject;

        /**
         * Creates a plain object from a ResponseFrame message. Also converts values to other types if specified.
         * @param {stomp.ResponseFrame} message ResponseFrame
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseFrame.toObject = function toObject(message, options) {
            if (!options)
                options = {};
            let object = {};
            if (message.connected != null && message.hasOwnProperty("connected")) {
                object.connected = $root.stomp.ConnectedResponse.toObject(message.connected, options);
                if (options.oneofs)
                    object.response = "connected";
            }
            if (message.singleMessage != null && message.hasOwnProperty("singleMessage")) {
                object.singleMessage = $root.stomp.MessageResponse.toObject(message.singleMessage, options);
                if (options.oneofs)
                    object.response = "singleMessage";
            }
            if (message.batchMessages != null && message.hasOwnProperty("batchMessages")) {
                object.batchMessages = $root.stomp.MessageResponses.toObject(message.batchMessages, options);
                if (options.oneofs)
                    object.response = "batchMessages";
            }
            if (message.receipt != null && message.hasOwnProperty("receipt")) {
                object.receipt = $root.stomp.ReceiptResponse.toObject(message.receipt, options);
                if (options.oneofs)
                    object.response = "receipt";
            }
            if (message.serverError != null && message.hasOwnProperty("serverError")) {
                object.serverError = $root.stomp.ServerErrorResponse.toObject(message.serverError, options);
                if (options.oneofs)
                    object.response = "serverError";
            }
            if (message.subscriptionError != null && message.hasOwnProperty("subscriptionError")) {
                object.subscriptionError = $root.stomp.SubscriptionErrorResponse.toObject(message.subscriptionError, options);
                if (options.oneofs)
                    object.response = "subscriptionError";
            }
            if (message.heartbeat != null && message.hasOwnProperty("heartbeat")) {
                object.heartbeat = $root.stomp.Heartbeat.toObject(message.heartbeat, options);
                if (options.oneofs)
                    object.response = "heartbeat";
            }
            return object;
        };

        /**
         * Creates a plain object from this ResponseFrame message. Also converts values to other types if specified.
         * @param {$protobuf.ConversionOptions} [options] Conversion options
         * @returns {Object.<string,*>} Plain object
         */
        ResponseFrame.prototype.toObject = function toObject(options) {
            return this.constructor.toObject(this, options);
        };

        /**
         * Converts this ResponseFrame to JSON.
         * @returns {Object.<string,*>} JSON object
         */
        ResponseFrame.prototype.toJSON = function toJSON() {
            return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
        };

        return ResponseFrame;
    })();

    return stomp;
})();

export { $root as default };
